import { UserResponse } from './../../shared-resources/interfaces/base-core-services.interface';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from '@delon/theme';
import { ACLWrapperService } from 'src/app/shared-resources/services/acl-wrapper.service';
import { UserInfoService } from 'src/app/shared-resources/services/user-info.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less'],
})
export class HeaderComponent implements OnInit {
  public isCollapsed = true;
  public searchToggleStatus: boolean;
  public showLangugeMenuAfterLogin = true;
  public isNewUser = false;
  public userInfo: UserResponse;
  constructor(
    private router: Router,
    public settings: SettingsService,
    public aclSrv: ACLWrapperService,
    public userService: UserInfoService
  ) {}

  toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed;
  }
  toggleCollapsedSidebar(): void {
    this.settings.setLayout('collapsed', !this.settings.layout.collapsed);
  }

  searchToggleChange(): void {
    this.searchToggleStatus = !this.searchToggleStatus;
  }
  goto(): void {
    this.router.navigateByUrl('business-registration');
  }

  gotoGatePass(): void {
    this.router.navigateByUrl('gate-pass');
  }

  gotoinquiry(): void {
    this.router.navigateByUrl('business-inquiry');
  }

  ngOnInit(): void {
   // this.userInfo = this.userService.getUserInfo();
    if (this.userInfo && this.userInfo.userName) {
      this.showLangugeMenuAfterLogin = !this.userService.getUserName();
      this.isNewUser = !this.userService.getUserCustomerId();
    } else {
      this.userService.getUserInfo$().subscribe(() => {
        this.showLangugeMenuAfterLogin = !this.userService.getUserName();
        this.isNewUser = !this.userService.getUserCustomerId();
      });
    }
  }
}
